import { Component, defineComponent } from '@decify/cell-shopify/client';
import './ProductListAction.scss';
export const productListActionName = 'ProductListAction';
export const productListActionTagName = 'cell-component-product-list-action';
export const productListActionClickEvent = 'click';
export class ProductListAction extends Component {
    constructor() {
        super(productListActionName);
        this.handleClick = this.handleClick.bind(this);
    }
    componentDidMount() {
        this.subscribe('click', this.handleClick);
    }
    handleClick() {
        this.publish(productListActionClickEvent);
    }
    getName() {
        const innerElement = this.querySelector('.ProductListAction__Inner');
        if (!innerElement) {
            throw new Error('ProductListAction: inner element not found');
        }
        const name = innerElement.getAttribute('name');
        if (!name) {
            throw new Error('ProductListAction: name attribute not found');
        }
        return name;
    }
}
defineComponent(productListActionTagName, ProductListAction);
